import {createSelector} from '@ngrx/store';
import {AppState} from '../states/app.state';
import {identity} from 'rxjs';

export class DubletteNoticeDialogSelectors {
  private static select = {
    isOpen: (state: AppState) => state.dubletteNoticeDialog?.isOpen,
    intent: (state: AppState) => state.dubletteNoticeDialog?.intent,
  };

  public static isOpen = createSelector(this.select.isOpen, identity);

  public static intent = createSelector(this.select.intent, identity);
}
